/**
 * Tastatursteuerung: Pfeile, Bild auf/ab, Pos1/Ende, Leertaste.
 */

const TEXT_INPUT_TAGS = /^(input|textarea|select)$/i;

export class KeyboardHandler {
	/**
	 * @param {Object} cb Callbacks:
	 *   isApplicable()    → bool (Engine aktiv + Wrapper im Viewport)
	 *   onNavigate(dir)   → bool (behandelt?)
	 *   onEdge(pos)       → bool ('home' | 'end')
	 *   onHorizontal(dir) → bool
	 */
	constructor( cb ) {
		this.cb = cb;
		this.handle = this.handle.bind( this );
		window.addEventListener( 'keydown', this.handle );
	}

	handle( event ) {
		if ( event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey ) {
			return;
		}

		if ( ! this.cb.isApplicable() ) {
			return;
		}

		const target = event.target;

		if ( target instanceof Element ) {
			// In Formularfeldern steuern die Tasten den Cursor.
			if ( TEXT_INPUT_TAGS.test( target.tagName ) || target.isContentEditable ) {
				return;
			}

			// Space aktiviert fokussierte Buttons/Links — nicht kapern.
			if ( event.key === ' ' && target.closest( 'button, a, [role="button"]' ) ) {
				return;
			}
		}

		let handled = false;

		switch ( event.key ) {
			case 'ArrowDown':
			case 'PageDown':
				handled = this.cb.onNavigate( 1 );
				break;
			case 'ArrowUp':
			case 'PageUp':
				handled = this.cb.onNavigate( -1 );
				break;
			case ' ':
				handled = this.cb.onNavigate( event.shiftKey ? -1 : 1 );
				break;
			case 'Home':
				handled = this.cb.onEdge( 'home' );
				break;
			case 'End':
				handled = this.cb.onEdge( 'end' );
				break;
			case 'ArrowRight':
				handled = this.cb.onHorizontal( 1 );
				break;
			case 'ArrowLeft':
				handled = this.cb.onHorizontal( -1 );
				break;
			default:
				return;
		}

		if ( handled ) {
			event.preventDefault();
		}
	}

	destroy() {
		window.removeEventListener( 'keydown', this.handle );
	}
}
